module.exports = __webpack_public_path__ + "static/media/ben Jenkins.2a09116d.jfif";